import React from 'react';

import classes from './forCarriers.module.scss';

export const ForCarriers = () => {
  return (
    <div className={classes.ForCarriers}>
      <div className={classes.ForCarriersSection}>
        <div className={classes.ForCarriersLabel}>For Carriers</div>
        <div className={classes.ForCarriersTitle}>
          The right data. The right groups. The right outcomes.
        </div>
        <div className={classes.ForCarriersDescription}>
          Monark unlocks:
        </div>
        
        <div className={classes.ForCarriersList}>
          <div className={classes.ForCarriersListItem}>
            • Access to high-quality group business
          </div>
          <div className={classes.ForCarriersListItem}>
            • Real-time insights
          </div>
          <div className={classes.ForCarriersListItem}>
            • Smarter targeting, pricing, and service models
          </div>
        </div>

        <div className={classes.ForCarriersSubsection}>
          <div className={classes.ForCarriersSubsectionTitle}>
            Monark Preferred Carriers Receive
          </div>
          
          <div className={classes.ForCarriersSubsectionList}>
            <div className={classes.ForCarriersListItem}>
              • Easily reply to any RFP
            </div>
            <div className={classes.ForCarriersListItem}>
              • Co-branded quote portal for your brokers
            </div>
            <div className={classes.ForCarriersListItem}>
              • Ensure RFPs are sent to the right sales rep
            </div>
            <div className={classes.ForCarriersListItem}>
              • Promote sales reps to brokers
            </div>
            <div className={classes.ForCarriersListItem}>
              • Track your win rates
            </div>
            <div className={classes.ForCarriersListItem}>
              • RFP underwriting exports
            </div>
            <div className={classes.ForCarriersListItem}>
              • Instant web-based proposals
            </div>
            <div className={classes.ForCarriersListItem}>
              • Broker deal room chat access
            </div>
            <div className={classes.ForCarriersListItem}>
              • Reporting
            </div>
            <div className={classes.ForCarriersListItem}>
              • Team Workflows
            </div>
            <div className={classes.ForCarriersListItem}>
              • Deal recommendations
            </div>
            <div className={classes.ForCarriersListItem}>
              • Deal Loss alerts
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};